import clsx from "clsx";

export function Stacker({ className, ...props }) {
  return (
    <div
      className={clsx(
        "pb-10 2xs:space-y-2 xs:space-y-4 md:space-y-8 md:pb-14 lg:space-y-14 lg:pb-20",
        className
      )}
      {...props}
    />
  );
}
